import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { HiOutlinePlusCircle } from 'react-icons/hi';
import ItemService from '../service/ItemService';
import ShopService from '../service/ShopService';
import ShopListCard from './ShopListCard';
import '../css/admin.css'


const DefaultItemsListEdit = () => {
    const history = useHistory();
    const [d0, setd0] = useState(null);
    const [d1, setd1] = useState(null);
    const [brands, setBrands] = useState(null);
    const [categoriesError, setCategoriesError] = useState(false)
    const [sizesError, setSizesError] = useState(false)
    const [brandsError, setBrandsError] = useState(false)

    const reloadPage = useCallback(() => {
        setCategoriesError(false)
        ItemService.getShopCategories().then(res => {
            if (res.status) {
                setd0(res.data.data || [])
            }
        }).catch(error => {
            console.log(error)
            setCategoriesError(true)
        });
    }, [])

    const reloadSize = useCallback(() => {
        setSizesError(false)
        ItemService.getItemSizes(0).then(res => {
            if (res.status) {
                setd1(res.data.data)
            }
        }).catch(error => {
            console.log(error)
            setSizesError(true)
        });
    }, [])

    // the list stays on screen while it reloads after a save
    const reloadBrands = useCallback(() => {
        setBrandsError(false)
        ShopService.getBrands().then(res => {
            setBrands(Array.isArray(res.data.data) ? res.data.data : [])
        }).catch(error => {
            console.log(error)
            setBrandsError(true)
        });
    }, [])

    useEffect(() => {
        reloadPage()
        reloadSize()
        reloadBrands()
    }, [reloadPage, reloadSize, reloadBrands]);

    return (
        <main className='mv-page'>
            <div className='mv-page-head'>
                <div>
                    <h1 className='mv-list-title'>Inventory</h1>
                    <p className='mv-page-sub'>Categories, sizes, brands and home page picks.</p>
                </div>
                <button type='button' className='mv-btn mv-btn-primary mv-btn-sm' onClick={() => history.push('/shop/item/create')}>
                    <HiOutlinePlusCircle /> Add product
                </button>
            </div>

            <ShopListCard
                reloadAction={reloadPage}
                reloadActionSizes={reloadSize}
                list={d0}
                sizeData={d1}
                categoriesError={categoriesError}
                sizesError={sizesError}
                brands={brands}
                brandsError={brandsError}
                reloadActionBrands={reloadBrands}
            />
        </main>
    );
};

export default DefaultItemsListEdit;
